import { useEffect, useState } from "react";
import { ensureWebToken } from "./services/auth";
import { getRestaurantById } from "./services/restaurant";
import { getAllFood, getFoodCategories } from "./services/menu";
import { IRestaurant } from "./models/IRestaurant";
import { IFood } from "./models/IFood";
import { IFoodCategory } from "./models/IFoodCategory";
import { RESTAURANT_ID } from "./config/restaurantConfig";
import { getReservationIdFromPath } from "./utils/routing";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Menu from "./components/Menu";
import ReservationForm from "./components/ReservationForm";
import ReservationTicket from "./components/ReservationTicket";
import Footer from "./components/Footer";

export default function App() {
  const reservationId = getReservationIdFromPath();
  const [restaurant, setRestaurant] = useState<IRestaurant | null>(null);
  const [foods, setFoods] = useState<IFood[]>([]);
  const [categories, setCategories] = useState<IFoodCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (reservationId) {
      setLoading(false);
      return;
    }
    ensureWebToken()
      .then(() =>
        Promise.all([
          getRestaurantById(RESTAURANT_ID),
          getAllFood(RESTAURANT_ID),
          getFoodCategories(),
        ])
      )
      .then(([restaurantRes, foodsRes, categoriesRes]) => {
        setRestaurant(restaurantRes.data);
        setFoods(foodsRes.data ?? []);
        setCategories(categoriesRes.data ?? []);
      })
      .catch(() => setError("Restoran bilgileri yüklenirken bir sorun oluştu. Lütfen daha sonra tekrar deneyin."))
      .finally(() => setLoading(false));
  }, [reservationId]);

  if (reservationId) {
    return <ReservationTicket reservationId={reservationId} />;
  }

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#1c1a17" }}>
        <div className="spinner-border" style={{ color: "#b8934a", width: 44, height: 44 }} role="status" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#1c1a17", padding: 24 }}>
        <div style={{ color: "#fff", textAlign: "center", maxWidth: 420 }}>
          <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: "2.4rem", color: "#e07a5f" }}></i>
          <p style={{ marginTop: 16 }}>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Navbar restaurant={restaurant} />
      <Hero restaurant={restaurant} />
      <About restaurant={restaurant} />
      <Menu foods={foods} categories={categories} />
      <ReservationForm />
      <Footer restaurant={restaurant} />
    </>
  );
}
